export const INVOICE_ADDRESS_CONSTANTS = {
  EMAIL_PATTERN: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  /** `InvoiceAddressesTable::validationDefault()` — exceeding either caps the booking at saveOrFail. */
  MAX_FIELD_LENGTH: 255,
  MAX_STREET_NUMBER_LENGTH: 50,
} as const;
